import React from "react";

const PageNotFound = React.memo(props => {
  return (
    <div className="right-wrpr text-center bold no-page">
      <div className="container">Page not found</div>
    </div>
  );
});

export default PageNotFound;
